export default "__VITE_ASSET__86bd6cc4__"